/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown>, total: NonNullable<unknown> }} Plan_Phase_ProgressionInputs */

const en_us2_plan_phase_progression = /** @type {(inputs: Plan_Phase_ProgressionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Progression phase · week ${i?.week} of ${i?.total}`)
};

const pt_br2_plan_phase_progression = /** @type {(inputs: Plan_Phase_ProgressionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fase de progressão · semana ${i?.week} de ${i?.total}`)
};

const es_419_plan_phase_progression = /** @type {(inputs: Plan_Phase_ProgressionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fase de progresión · semana ${i?.week} de ${i?.total}`)
};

const pt_pt2_plan_phase_progression = /** @type {(inputs: Plan_Phase_ProgressionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fase de progressão · semana ${i?.week} de ${i?.total}`)
};

const fr_fr2_plan_phase_progression = /** @type {(inputs: Plan_Phase_ProgressionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Phase de progression · semaine ${i?.week} sur ${i?.total}`)
};

const de_de2_plan_phase_progression = /** @type {(inputs: Plan_Phase_ProgressionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Progressionsphase · Woche ${i?.week} von ${i?.total}`)
};

const it_it2_plan_phase_progression = /** @type {(inputs: Plan_Phase_ProgressionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fase di progressione · settimana ${i?.week} di ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Progression phase · week {week} of {total}" |
*
* @param {Plan_Phase_ProgressionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_phase_progression = /** @type {((inputs: Plan_Phase_ProgressionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Phase_ProgressionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_phase_progression(inputs)
	if (locale === "es-419") return es_419_plan_phase_progression(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_phase_progression(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_phase_progression(inputs)
	if (locale === "de-DE") return de_de2_plan_phase_progression(inputs)
	if (locale === "it-IT") return it_it2_plan_phase_progression(inputs)
	return en_us2_plan_phase_progression(inputs)
});
export { plan_phase_progression as "plan.phase.progression" }